import config from "../app/config";
import { shortUrl } from "../app/utils";
import type { Subscription } from "../app/types";

const routes = {
  login: "/login",
  app: config.app_root,
  account: "/account",
  settings: "/settings",
  subscription: "/:topic",
  subscriptionExternal: "/:baseUrl/:topic",
  forSubscription: (subscription: Pick<Subscription, "baseUrl" | "topic">) => {
    if (subscription.baseUrl !== config.base_url) {
      return `/${shortUrl(subscription.baseUrl)}/${subscription.topic}`;
    }
    return `/${subscription.topic}`;
  },
  /**
   * 맨 위 화면 — "모든 알림"과 구독 화면들. 서로는 탭 바꾸기처럼 기록을 쌓지 않고(replace),
   * 앱 뒤로가기는 여기서 바로 ntfy 를 나간다(구독을 여럿 돌아다닌 뒤 뒤로가기가 그 구독들을 되짚던 문제, 2026-10-07).
   * 설정·계정·로그인만 그 위에 쌓이는 화면이다.
   */
  isTopLevel: (path: string) => ![routes.account, routes.settings, routes.login].includes(path.replace(/\/+$/, "") || "/"),
};

export default routes;
